export interface IAuthResponse {
  token: string;
  expires: number;
  refreshToken: string;
  refreshTokenExpires: number;
  require2FA: boolean;
  requireOTP: boolean;
  token2FA: string | null;
  token2FAExpires: number;
  requireServiceCode: boolean;
  tokenServiceCode: string | null;
  tokenServiceCodeExpires: number;
  isPasswordChangeRequired: boolean;
}

export type LoginMutation = {
  email: string;
  password: string;
};

export type LoginTwoFactorMutation = {
  email: string;
  code: string;
  token: string;
};

export interface IResendTwoFactor {
  email: string;
  token: string;
}

export type LoginResponse = {
  token: string;
  expires: number;
  refreshToken: string;
  refreshTokenExpires: number;
  require2FA: boolean;
  token2FAExpires: number | null;
  token2FA: string;
  isPasswordChangeRequired: boolean;
};

export type RefreshTokenMutation = {
  token: string;
};

export type RefreshTokenResponse = {
  token: string;
  expires: number;
  refreshToken: string;
  refreshTokenExpires: number;
  require2FA: boolean;
  token2FA?: string;
  isPasswordChangeRequired: boolean;
};

export interface IRegisterForm {
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
  repeatPassword: string;
}

export interface IRequestResetPasswordForm {
  email: string;
}
export interface IResetPasswordMutation extends IRequestResetPasswordForm {
  token: string;
  newPassword: string;
}

export interface IResetPasswordForm extends IResetPasswordMutation {
  newPasswordConfirm: string;
}

export interface IResendConfirmEmailForm {
  email: string;
}

export interface IConfirmEmailForm extends IResendConfirmEmailForm {
  token: string;
}
export interface IConfirmEmailWithPasswordForm extends IConfirmEmailForm {
  token: string;
  password: string;
  passwordCopy: string;
}

export interface ILoginServiceCode {
  token: string;
  serviceCode: string;
}

export interface IChangePasswordForm {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface IOtpCodeForm {
  code: string;
}
export enum USER_SOURCE {
  local = 1,
  client = 2,
}

export interface IAuthUserSource {
  name: string;
  id: number;
}

export interface IAuthUser {
  id: string;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phoneNumber: string;
  isActive: boolean;
  source: IAuthUserSource;
}
